import React from 'react';
import { Box, Card, CardContent, Typography, Grid, Avatar, Chip, Alert } from '@mui/material';
import { Inventory, Warning, PointOfSale, AttachMoney } from '@mui/icons-material';
import { dashboard, alertasStock, ventasPorTienda, sucursalActual, formatearMoneda, nombreTienda } from '../data';

function Tarjeta({ titulo, valor, icono: Icono, color }) {
  return (
    <Card>
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="body2" color="text.secondary">{titulo}</Typography>
            <Typography variant="h4" fontWeight={700} mt={0.5}>{valor}</Typography>
          </Box>
          <Avatar sx={{ bgcolor: `${color}.main`, width: 48, height: 48 }}><Icono /></Avatar>
        </Box>
      </CardContent>
    </Card>
  );
}

function Dashboard() {
  const hoy = new Date().toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <Box>
      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Bienvenido al Demo WHS
        </Typography>
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
          <Chip label="Administrador General" size="small" color="primary" variant="outlined" />
          <Chip label={sucursalActual.nombre} size="small" sx={{ bgcolor: sucursalActual.color_primario, color: '#fff' }} />
        </Box>
        <Typography variant="body2" color="text.secondary" mt={1}>{hoy}</Typography>
      </Box>

      <Alert severity="info" sx={{ mb: 3 }}>
        Este es un demo de solo lectura con datos estáticos. No se pueden modificar, agregar ni eliminar datos.
      </Alert>

      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} sm={6} md={3}>
          <Tarjeta titulo="Productos Totales" valor={dashboard.total_productos} icono={Inventory} color="primary" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Tarjeta titulo="Stock Bajo" valor={alertasStock.length} icono={Warning} color="warning" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Tarjeta titulo="Ventas Hoy (simulado)" valor={dashboard.ventas_hoy} icono={PointOfSale} color="success" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Tarjeta titulo="Valor Inventario" valor={formatearMoneda(dashboard.valor_total_inventario)} icono={AttachMoney} color="info" />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Ventas por Tienda (simulado)</Typography>
              {ventasPorTienda.map((v) => (
                <Box key={v.tienda} display="flex" justifyContent="space-between" py={0.75} borderBottom="1px solid #eee">
                  <Typography variant="body2">{nombreTienda(v.tienda)}</Typography>
                  <Typography variant="body2" fontWeight={600}>{formatearMoneda(v.total)}</Typography>
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>Alertas de Stock Bajo</Typography>
              {alertasStock.length === 0 ? (
                <Typography variant="body2" color="text.secondary">No hay productos con stock bajo.</Typography>
              ) : (
                alertasStock.map((p) => (
                  <Box key={p._id} display="flex" justifyContent="space-between" py={0.75} borderBottom="1px solid #eee">
                    <Box>
                      <Typography variant="body2" fontWeight={500}>{p.nombre}</Typography>
                      <Typography variant="caption" color="text.secondary">{p.categoria}</Typography>
                    </Box>
                    <Chip label={`Quedan ${p.stock}`} size="small" color="error" />
                  </Box>
                ))
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard;
